<p-popover #validationOverlayPanel
           [dismissable]="false"
           styleClass="sc-validation-error-panel">
  {{ errorMessage }}
</p-popover>